import { createReducer, on } from '@ngrx/store';
import { SyncQueueActions } from './sync-queue.actions';

export type SyncQueueState = {
  draining: boolean;
  error: string | null;
  lastEnqueuedId: string | null;
};

export const initialSyncQueueState: SyncQueueState = {
  draining: false,
  error: null,
  lastEnqueuedId: null,
};

export const syncQueueReducer = createReducer(
  initialSyncQueueState,
  on(SyncQueueActions.enqueueSucceeded, (state, { operation }) => ({
    ...state,
    error: null,
    lastEnqueuedId: operation.id,
  })),
  on(SyncQueueActions.enqueueFailed, (state, { error }) => ({
    ...state,
    error,
  })),
  on(SyncQueueActions.drainRequested, (state) => ({
    ...state,
    draining: true,
    error: null,
  })),
  on(SyncQueueActions.drainCompleted, (state) => ({
    ...state,
    draining: false,
  })),
  on(SyncQueueActions.drainFailed, (state, { error }) => ({
    ...state,
    draining: false,
    error,
  })),
);
